/**
 * Validation utilities for job-related content.
 */

/**
 * Checks if a string contains any HTTP/HTTPS URLs.
 */
export function hasUrl(content: string): boolean {
  return /https?:\/\/\S+/i.test(content);
}
